import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Contact() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.1 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  return (
    <div className="w-full bg-white text-butter-text pt-24 pb-20 md:pt-32 md:snap-start min-h-screen flex flex-col">
      <div className="max-w-[1280px] w-full mx-auto px-6 md:px-12 lg:px-16 flex-grow flex flex-col justify-center">
        
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="w-full max-w-5xl">
          
          {/* Contact Intro */}
          <div className="mb-16 md:mb-24">
            <motion.span variants={itemVariants} className="font-butter-sans text-[11px] uppercase tracking-[0.2em] text-butter-muted mb-4 block">
              contact
            </motion.span>
            <motion.h1 variants={itemVariants} className="font-butter-serif text-[44px] md:text-[60px] text-butter-text leading-tight mb-4">
              open for collabs
            </motion.h1>
            <motion.p variants={itemVariants} className="font-butter-sans text-[18px] md:text-[22px] text-butter-muted italic font-light">
              for portrait sessions, creative collaborations, or a quiet hello.
            </motion.p>
          </div>

          {/* Contact Details Block */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24 border-t border-butter-line pt-16">
            
            {/* Left: Contact Info */}
            <motion.div variants={itemVariants} className="flex flex-col gap-10">
              <div>
                <h3 className="font-butter-sans text-[11px] uppercase tracking-[0.2em] text-butter-muted mb-2">instagram</h3>
                <a href="https://instagram.com/buttersando" target="_blank" rel="noopener noreferrer" className="font-butter-serif text-[24px] md:text-[28px] text-butter-text hover:text-butter-accent transition-colors">
                  @buttersando
                </a>
              </div>
              <div>
                <h3 className="font-butter-sans text-[11px] uppercase tracking-[0.2em] text-butter-muted mb-2">email</h3>
                <a href="mailto:ivansridana@gmail.com" className="font-butter-serif text-[24px] md:text-[28px] text-butter-text hover:text-butter-accent transition-colors">
                  ivansridana@gmail.com
                </a>
              </div>
              <div>
                <h3 className="font-butter-sans text-[11px] uppercase tracking-[0.2em] text-butter-muted mb-2">based in</h3>
                <p className="font-butter-serif text-[24px] md:text-[28px] text-butter-text">
                  jakarta, sometimes bali
                </p>
              </div>
            </motion.div>

            {/* Right: Note & Buttons */}
            <motion.div variants={itemVariants} className="flex flex-col justify-start">
              <p className="font-butter-sans text-[16px] md:text-[18px] leading-[1.7] text-butter-muted mb-10 max-w-sm bg-[#F8F6F2] p-6 rounded-sm border border-butter-line/50">
                instagram is the fastest way to reach me for photography-related inquiries.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="https://instagram.com/buttersando" target="_blank" rel="noopener noreferrer" className="font-butter-sans text-[13px] uppercase tracking-[0.15em] bg-butter-dark text-white px-8 py-4 rounded-sm hover:bg-butter-hover transition-colors text-center">
                  say a quiet hello on ig
                </a>
                {/* Diubah arah dan teksnya */}
                <Link to="/photography" className="font-butter-sans text-[13px] uppercase tracking-[0.15em] text-butter-text border border-butter-line px-8 py-4 rounded-sm hover:border-butter-accent hover:text-butter-accent transition-colors text-center">
                  back to home
                </Link>
              </div>
            </motion.div>

          </div>

        </motion.div>
      </div>
    </div>
  );
}